import * as React from 'react';
import { observer } from 'mobx-react';

// Types
import { INotificationAll } from './NotificationList';

// Components
import { FancyAvatar } from '../../components/Avatar';
import { ModifiedBadge } from '../../components/Badge';
import Button from '../../components/Button';
import Icon from '../../components/Icon';
import IconButton from '../../components/IconButton';
import Card, {
  CardHeader,
  CardContent,
  CardActions
} from '../../components/Card';
import Divider from '../../components/Divider';
import Typography from '../../components/Typography';

// Component
interface IProps {
  question: INotificationAll;
  onRequestQuestion: () => void;
  onRequestComment: () => void;
  attention?: boolean;
}

function NotificationCard(props: IProps) {
  return (
    <Card
      style={{
        marginBottom: 16,
        borderTop: props.attention ? '2px solid #FF4A5D' : null
      }}
    >
      <CardHeader
        avatar={
          <FancyAvatar
            src={props.question.authorPhotoUrl}
            text={`${props.question.authorFirstName} ${
              props.question.authorLastName
            }`}
          />
        }
        title={`${props.question.authorFirstName} ${
          props.question.authorLastName
        }`}
        subheader={props.question.networkName}
      />
      <Divider />
      <CardContent>
        <Typography type="headline">{props.question.description}</Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Button onClick={props.onRequestQuestion}>Show Results</Button>
        <span style={{ flexGrow: 1 }} />
        <IconButton onClick={props.onRequestComment}>
          {props.question.commentCount === 0 ? (
            <Icon>comment</Icon>
          ) : (
            <ModifiedBadge
              badgeContent={props.question.commentCount}
              color="primary"
            >
              <Icon>comment</Icon>
            </ModifiedBadge>
          )}
        </IconButton>
      </CardActions>
    </Card>
  );
}

export default observer(NotificationCard);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetworkHome/NotificationListItem.tsx